import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useClientByIdQuery } from 'api';

export const useGeneral = () => {
  const [modalState, setModalState] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data: clientDetails = {} } = useClientByIdQuery({ id });

  const onModalStateChange = useCallback(() => setModalState((prevState) => !prevState), []);
  return {
    modalState,
    clientDetails,
    onModalStateChange,
  };
};
